import { render, staticRenderFns } from "./LoginEndConfiguration.vue?vue&type=template&id=bb157de2&"
import script from "./LoginEndConfiguration.vue?vue&type=script&lang=js&"
export * from "./LoginEndConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports